/**
 * @fileoverview Configuration settings for the application.
 *
 * @example
 * const config = require('./config')
 */

/**
 * @interface Config
 * @description Configuration settings for the application.
 * @property {string} api - The API host.
 * @property {Object} s3 - The S3 configuration.
 * @property {Object} s3.buckets - The S3 buckets.
 */
export interface Config {
    api: string
    s3: {
        buckets: Record<'static', string>
    }
}

const config: Config = {
    api: process.env.CRM_HOST,
    s3: {
        buckets: {
            static: 'https://novoic-static.s3.us-west-2.amazonaws.com',
        },
    },
}

/**
 * @enum States
 * @description The states of a participant.
 * @property {string} review - The review state.
 * @property {string} not_qualified - The not qualified state.
 * @property {string} qualified - The qualified state.
 * @property {string} invited - The invited state.
 * @property {string} excluded - The excluded state.
 * @property {string} randomised - The randomised state.
 */
export enum States {
    review = 'review',
    not_qualified = 'not_qualified',
    qualified = 'qualified',
    invited = 'invited',
    excluded = 'excluded',
    randomised = 'randomised',
}

export default config

/**
 * @interface Filters
 * @description The filters for the tests and participants.
 * @property {Object} tests - The filters for the tests.
 * @property {Object} participants - The filters for the participants.
 */
interface Filters {
    tests: {
        assigned: string
        incomplete: string
        review: string
        bookmarked: string
        selected: string
        excluded: string
    }
    participants: {
        review: string
        qualified: string
        invited: string
        not_qualified: string
        excluded: string
        randomised: string
    }
}

export const filters: Filters = {
    tests: {
        assigned: 'status=assigned&has_review=false',
        incomplete: 'status=incomplete&status=timeout&status=cancelled&has_review=false',
        review: 'status=complete&has_review=false',
        bookmarked: 'review_decision=bookmarked',
        selected: 'review_decision=selected',
        excluded: 'review_decision=excluded',
    },
    participants: {
        review: 'status=review',
        qualified: 'status=qualified',
        invited: 'status=invited',
        not_qualified: 'status=not_qualified',
        excluded: 'status=excluded',
        randomised: 'status=randomised',
    },
}
